"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscapeKeyController = void 0;
// 겹쳐 열린 표면이 ESC 한 번에 모두 닫히지 않도록, 열린 순서대로 쌓아 맨 위 하나만 받게 한다.
// document 리스너는 쌓인 표면이 있는 동안 하나만 건다.
const openSurfaces = [];
const handleDocumentKeydown = (event) => {
    if (event.key !== 'Escape')
        return;
    openSurfaces[openSurfaces.length - 1]?.dismiss();
};
const push = (controller) => {
    if (openSurfaces.includes(controller))
        return;
    if (openSurfaces.length === 0)
        document.addEventListener('keydown', handleDocumentKeydown);
    openSurfaces.push(controller);
};
const remove = (controller) => {
    const index = openSurfaces.indexOf(controller);
    if (index < 0)
        return;
    openSurfaces.splice(index, 1);
    if (openSurfaces.length === 0)
        document.removeEventListener('keydown', handleDocumentKeydown);
};
/**
 * ESC 키를 누르면 콜백을 호출하는 ReactiveController.
 *
 * 열려 있는 표면을 열린 순서대로 쌓고 ESC는 맨 위 표면 하나만 처리한다. dialog 안에서 popover를 연 것처럼
 * 표면이 겹쳐 있어도 한 번에 한 겹씩 닫힌다. 맨 위 표면이 ESC로 닫히지 않는 modal이어도 아래 표면으로 넘기지 않는다.
 * 쌓고 빼는 일과 document 리스너는 이 컨트롤러가 연결·렌더·해제 시점에 맡으므로,
 * 컴포넌트마다 connectedCallback/disconnectedCallback에 같은 코드를 반복하지 않는다.
 * OutsideClickController와 함께 떠 있는 표면이 스스로 닫히는 수단을 이룬다.
 * 열림 여부는 `OpenState` 호스트의 `open`을 읽고, 콜백을 생략하면 `close()`를 부른다.
 * 닫는 조건을 따로 가진 표면(SheetController의 dismissOn)만 콜백을 넘긴다.
 */
class EscapeKeyController {
    constructor(host, onEscape = () => host.close()) {
        this.host = host;
        this.onEscape = onEscape;
        host.addController(this);
    }
    hostConnected() {
        this.syncStack();
    }
    hostUpdated() {
        this.syncStack();
    }
    hostDisconnected() {
        remove(this);
    }
    /** 맨 위 표면이 ESC를 받으면 모듈의 document 리스너가 부른다. */
    dismiss() {
        this.onEscape();
    }
    // 열리면 맨 위에 쌓고 닫히면 뺀다. 이미 열려 있는 표면은 쌓인 자리를 유지한다.
    syncStack() {
        if (this.host.open)
            push(this);
        else
            remove(this);
    }
}
exports.EscapeKeyController = EscapeKeyController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXNjYXBlLWtleS1jb250cm9sbGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZXNjYXBlLWtleS1jb250cm9sbGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdBLDJEQUEyRDtBQUMzRCxxQ0FBcUM7QUFDckMsTUFBTSxZQUFZLEdBQTBCLEVBQUUsQ0FBQTtBQUU5QyxNQUFNLHFCQUFxQixHQUFHLENBQUMsS0FBb0IsRUFBRSxFQUFFO0lBQ3JELElBQUksS0FBSyxDQUFDLEdBQUcsS0FBSyxRQUFRO1FBQUUsT0FBTTtJQUVsQyxZQUFZLENBQUMsWUFBWSxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsRUFBRSxPQUFPLEVBQUUsQ0FBQTtBQUNsRCxDQUFDLENBQUE7QUFFRCxNQUFNLElBQUksR0FBRyxDQUFDLFVBQStCLEVBQUUsRUFBRTtJQUMvQyxJQUFJLFlBQVksQ0FBQyxRQUFRLENBQUMsVUFBVSxDQUFDO1FBQUUsT0FBTTtJQUU3QyxJQUFJLFlBQVksQ0FBQyxNQUFNLEtBQUssQ0FBQztRQUFFLFFBQVEsQ0FBQyxnQkFBZ0IsQ0FBQyxTQUFTLEVBQUUscUJBQXFCLENBQUMsQ0FBQTtJQUMxRixZQUFZLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFBO0FBQy9CLENBQUMsQ0FBQTtBQUVELE1BQU0sTUFBTSxHQUFHLENBQUMsVUFBK0IsRUFBRSxFQUFFO0lBQ2pELE1BQU0sS0FBSyxHQUFHLFlBQVksQ0FBQyxPQUFPLENBQUMsVUFBVSxDQUFDLENBQUE7SUFDOUMsSUFBSSxLQUFLLEdBQUcsQ0FBQztRQUFFLE9BQU07SUFFckIsWUFBWSxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUE7SUFDN0IsSUFBSSxZQUFZLENBQUMsTUFBTSxLQUFLLENBQUM7UUFBRSxRQUFRLENBQUMsbUJBQW1CLENBQUMsU0FBUyxFQUFFLHFCQUFxQixDQUFDLENBQUE7QUFDL0YsQ0FBQyxDQUFBO0FBRUQ7Ozs7Ozs7Ozs7R0FVRztBQUNILE1BQWEsbUJBQW1CO0lBQzlCLFlBQ1UsSUFBd0MsRUFDeEMsV0FBdUIsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRTtRQUR6QyxTQUFJLEdBQUosSUFBSSxDQUFvQztRQUN4QyxhQUFRLEdBQVIsUUFBUSxDQUFpQztRQUVqRCxJQUFJLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQzFCLENBQUM7SUFFRCxhQUFhO1FBQ1gsSUFBSSxDQUFDLFNBQVMsRUFBRSxDQUFBO0lBQ2xCLENBQUM7SUFFRCxXQUFXO1FBQ1QsSUFBSSxDQUFDLFNBQVMsRUFBRSxDQUFBO0lBQ2xCLENBQUM7SUFFRCxnQkFBZ0I7UUFDZCxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDZCxDQUFDO0lBRUQsOENBQThDO0lBQzlDLE9BQU87UUFDTCxJQUFJLENBQUMsUUFBUSxFQUFFLENBQUE7SUFDakIsQ0FBQztJQUVELGdEQUFnRDtJQUN4QyxTQUFTO1FBQ2YsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUk7WUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7O1lBQ3pCLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUNuQixDQUFDO0NBQ0Y7QUE5QkQsa0RBOEJDIn0=